module.exports = __webpack_public_path__ + "resources/media/Eclipse.a01cce43.svg";